import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to build a Flutter app?",
    answer: ` <p>The cost of developing a Flutter app can vary greatly based on a number of factors, including the app's complexity, features required, design complexity, and development hours. 
    However, our hourly rate for developing a Flutter app is $35/hr.</p>`,
  },
  {
    question: "How much does it cost to hire a dedicated Flutter developer?",
    answer: `<p>The cost of hiring a dedicated Flutter app developer can vary depending on several factors such as their level of experience, location, and the complexity of the project.
    To hire a Flutter app developer, the hourly rates can range from $35 to $99/hr.</p>`,
  },
  {
    question: "Can TekRevol convert my existing app into Flutter?",
    answer: ` <p>Yes, TekRevol has the experience and capacity to migrate your current app to Flutter. Our Flutter app developers can examine your present app structure and function before effectively migrating it to the Flutter framework, assuring a smooth transfer.</p>`,
  },
  {
    question:
      "Why should I choose you over other Flutter development companies in UK?",
    answer: `<p>Choose us over other Flutter development App development companies in the UK because of our experience, track record, and user-focused approach. We create high-quality solutions targeted to your company's needs with an experienced Flutter app development team.</p> `,
  },
  {
    question: "How do I choose the best Flutter app development company?",
    answer: ` <p>Before searching for top Flutter app development companies, make a thorough strategy and budget.</p>
        <p>Examine possible development teams by reviewing their web presence, accessible technical stacks, and portfolios. You can trust us with your Flutter app development project.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
